export default "__VITE_ASSET__ClU7iMdr__"